import { createSelector } from '@ngrx/store';
import * as fromPaymentsAndInvoicesReducer from '../reducers';
import * as fromPaymentRunStatus from '../reducers/payment-run-status.reducer';

export const selectPaymentRunStatus = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentRunStatusState,
  fromPaymentRunStatus.getPaymentRunStatus
);
export const selectPaymentRunStatusIsLoaded = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentRunStatusState,
  fromPaymentRunStatus.getPaymentRunStatusIsLoaded
);
